import React from 'react';
import './PopUp.css';
import { ConfirmationPopupProps } from '@custom/Utils/constants/interfaces';
import { useTheme } from '@ohif/ui';

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({ isOpen, onConfirm, onCancel }) => {
  const { isDarkMode } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="popup-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center ">
      <div className="popup-container bg-white p-6 rounded-lg shadow-lg confrimation_popup">
        <h2 className="popup-heading-text" style={{ color: isDarkMode ? '#fff' : '#000' }}>Rollback Details!</h2>
        <p style={{ color: isDarkMode ? '#fff' : '#000' }}>Are you sure you want to Rollback this report?</p>
        <div className="popup-actions flex justify-start action ">
          <button className="custom-button" style={{marginLeft:"0px",  color: isDarkMode ? "#ffffff" : "#000000",
    borderColor: isDarkMode ? "#ffffff" : "#000000"}} onClick={onCancel}>No</button>
          <button className="custom-button main-theme" onClick={onConfirm}>Yes</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
